import { SVGProps } from 'react';
import { colors } from '@/utils/styles';

export default function ViewableDirectionIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 50 37" {...props}>
      <rect
        x="0.52"
        y="0.52"
        width="48.8569"
        height="35.9432"
        rx="4.32"
        fill="inherit"
        stroke="inherit"
        strokeWidth="0.96"
      />
      <rect
        x="1.48"
        y="1.48"
        width="46.9369"
        height="34.0232"
        rx="3.36"
        fill="inherit"
        stroke={colors.neutral[1000]}
        strokeWidth="0.96"
      />
      <path
        d="M16.21 30C20.228 30 23.42 25.1378 23.42 17.9916C23.42 10.8454 20.228 6 16.21 6C12.2031 6 9 10.8454 9 17.9916C9 25.1378 12.2031 30 16.21 30ZM16.21 28.1329C13.3377 28.1497 10.8867 24.0139 10.8867 17.9916C10.8867 12.0057 13.3349 7.88386 16.21 7.86706C19.127 7.85025 21.5669 11.9693 21.5669 17.9916C21.5669 23.9832 19.127 28.1161 16.21 28.1329ZM13.3634 22.64C15.5698 22.64 17.037 21.1084 17.037 18.7983C17.037 16.5189 15.5698 14.9734 13.3634 14.9734C11.1598 14.9734 9.69255 16.5189 9.69255 18.7983C9.69255 21.1084 11.1598 22.64 13.3634 22.64ZM12.3243 18.3479C11.8594 18.2807 11.5626 17.7207 11.6663 17.141C11.7839 16.5642 12.2402 16.1497 12.6883 16.2338C13.1671 16.3318 13.4471 16.875 13.3323 17.4378C13.2315 18.0175 12.7863 18.4291 12.3243 18.3479ZM32.5777 30C36.5818 30 39.7876 25.1378 39.7876 17.9916C39.7876 10.8454 36.5818 6 32.5777 6C28.5597 6 25.3677 10.8454 25.3677 17.9916C25.3677 25.1378 28.5597 30 32.5777 30ZM32.5777 28.119C29.6636 28.1218 27.2265 24 27.2265 17.9916C27.2265 12.0057 29.6607 7.88386 32.5777 7.88103C35.4557 7.87817 37.9067 11.9832 37.9067 17.9916C37.9067 23.9971 35.4557 28.1161 32.5777 28.119ZM29.7199 22.64C31.9095 22.64 33.3907 21.1084 33.3907 18.7983C33.3907 16.5189 31.9095 14.9734 29.7199 14.9734C27.5135 14.9734 26.0323 16.5189 26.0323 18.7983C26.0323 21.1084 27.5135 22.64 29.7199 22.64ZM28.6809 18.3479C28.216 18.2667 27.9163 17.7207 28.034 17.141C28.1516 16.5642 28.5829 16.1497 29.0449 16.2338C29.5097 16.3178 29.7897 16.875 29.6749 17.4378C29.5601 18.0175 29.1428 18.4291 28.6809 18.3479Z"
        fill={colors.neutral[900]}
      />
    </svg>
  );
}
